@if (showHeading) {
  <ng-content></ng-content>
}

@if (checklistContentInput) {
  <ul data-cy="checkListBulletsList">
    @for (bullet of checklistContentInput; track bullet) {
      <li data-cy="checkListBulletsListItem" [innerHTML]="bullet"></li>
    }
  </ul>
} @else {
  @if (content$ | async; as content) {
    <ul data-cy="checkListBulletsList">
      @for (bullet of content.checklistBullets; track bullet) {
        <li data-cy="checkListBulletsListItem" [innerHTML]="bullet"></li>
      }
    </ul>
  }
}


@if (showPhoneNumber) {
  <app-phone-blockquote></app-phone-blockquote>
}
